import Box from "@mui/material/Box";
import React, { useMemo } from "react";
import { AdvanceOutletInvoicingFooterJsons } from "../../../DynamicFormsJson/Transaction/advanceOutletInvoicingFooter";
import { ButtonCompo } from "../../../components/Comman/Button";
import { ChipCompo } from "../../../components/Comman/IconButton";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { noRecordsFoundMsgForOutletInvoicing } from "../../../config/messageconstant";
import CheckBoxSelectionTable from "../../OrderList/CheckBoxSelectionTable";
import { getOrderTableColumns } from "../constants/advanceOutletInvoicingTableColumns";
import {
	mutedBodyTextSx,
	outOfStockChipSx,
} from "../styles/advanceOutletInvoicingStyles";

const AdvanceOutletInvoicingOrderSection = ({
	flag,
	fieldData,
	selection,
	outletOrderDetail,
	stockHolderAndProductConfiguration,
	dynamicMasterData,
	filteredRows,
	onSelectionChange,
	onOutletOrderDetails,
	onCheckProductList,
	onProceed,
}) => {
	const outOfStockCount = useMemo(
		() => outletOrderDetail.filter((row) => !row.checked).length,
		[outletOrderDetail],
	);
	const orderTableColumns = useMemo(
		() => getOrderTableColumns(flag),
		[flag],
	);

	return (
		<>
			<CheckBoxSelectionTable
				enhancedLayout
				emptyMessage={noRecordsFoundMsgForOutletInvoicing}
				stockHolderAndProductConfiguration={stockHolderAndProductConfiguration}
				selection={selection}
				onSelectionChange={onSelectionChange}
				freeQtyFlag={fieldData.flag}
				columns={orderTableColumns}
				rows={filteredRows}
				setList={onOutletOrderDetails}
				isActionColActive={false}
				flag={flag}
				newRowData={outletOrderDetail}
			/>

			{outletOrderDetail.length !== 0 && (
				<Box className="order-list-action-bar">
					<Box className="order-list-action-bar-info">
						<TypographyCompo variant="body2" sx={mutedBodyTextSx}>
							Review quantities and proceed to billing
						</TypographyCompo>
						{flag && outOfStockCount > 0 && (
							<ChipCompo
								size="small"
								label={`${outOfStockCount} out of stock`}
								sx={outOfStockChipSx}
							/>
						)}
					</Box>
					<Box className="order-list-action-bar-buttons">
						{flag && (
							<ButtonCompo
								size="medium"
								type="button"
								variant="outlined"
								name="Negative Product List"
								onClick={onCheckProductList}
							/>
						)}
						<DynamicFormWithoutSave
							showBackToList={false}
							dynamicMasterData={dynamicMasterData}
							showSaveBtn={AdvanceOutletInvoicingFooterJsons.showSaveBtn}
							showTitle={AdvanceOutletInvoicingFooterJsons.showTitle}
							screenTitle={AdvanceOutletInvoicingFooterJsons.screenTitle}
							fieldMeta={AdvanceOutletInvoicingFooterJsons.fieldMeta}
							showCancel={AdvanceOutletInvoicingFooterJsons.showCancel}
							apiBaseURL={AdvanceOutletInvoicingFooterJsons.apiBaseURL}
							showSaveNextBtn={
								AdvanceOutletInvoicingFooterJsons.showSaveNextBtn
							}
							saveBtnText="Proceed"
							onSave={onProceed}
						/>
					</Box>
				</Box>
			)}
		</>
	);
};

export default React.memo(AdvanceOutletInvoicingOrderSection);
